import React, { ChangeEvent, FC, useCallback, useEffect, useState } from 'react'
import { z } from 'zod'
import { Header } from '../../components/header'
import { Steps } from '../../components/steps'

export const Input = z.object({
  header: z.string()
})
export type Input = z.infer<typeof Input>

export type Props = {
  goNextStep: (
    firstName: string,
    lastName: string,
    phone: string,
    status: string,
    comment: string
  ) => void
  goBackStep: () => void
}

export const Step_5: FC<Props> = ({ goNextStep, goBackStep }) => {
  const [input] = useState<Input | null>(() => {
    const inputContainer = document.getElementById('custom-sizes-step-5')
    const result = Input.safeParse(
      JSON.parse(inputContainer !== null ? inputContainer.innerText : '{}')
    )

    if (result.success) {
      return result.data
    }

    console.error(
      'Input data is invalid [8436e26ab1f4465d814ab60452c5a27b]',
      result.error
    )
    return null
  })

  const [showButton, setButton] = useState<boolean>(false)
  const [firstName, setFirstName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [status, setStatus] = useState<string>('')
  const [comment, setComment] = useState<string>('')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (firstName !== '' && lastName !== '' && phone !== '' && status !== '') {
      setButton(true)
    } else {
      setButton(false)
    }
  }, [firstName, lastName, phone, status])

  const changeStatus = useCallback((e: string) => {
    setStatus(e)
  }, [])

  const changeFirstName = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setFirstName(e.target.value)
  }, [])

  const changeLastName = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setLastName(e.target.value)
  }, [])

  const changePhone = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setPhone(e.target.value)
  }, [])

  const changeComment = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
    setComment(e.target.value)
  }, [])

  const goNext = useCallback(() => {
    goNextStep(firstName, lastName, phone, status, comment)
  }, [firstName, lastName, phone, status, comment, goNextStep])

  const goBack = useCallback(() => {
    goBackStep()
  }, [goBackStep])

  if (input == null) {
    return null
  }

  return (
    <div className="CS_Step5">
      <Steps step={5} allSteps={5} />
      {input.header && <Header text={input.header} />}

      <div className="CS_Step5-form">
        <div>
          <label className="CS_Step5-label">First Name</label>
          <input
            className="CS_Step5-input"
            value={firstName}
            onChange={changeFirstName}
          />
        </div>

        <div>
          <label className="CS_Step5-label">Last Name</label>
          <input
            className="CS_Step5-input"
            value={lastName}
            onChange={changeLastName}
          />
        </div>

        <div>
          <label className="CS_Step5-label">Phone</label>
          <input
            className="CS_Step5-input"
            value={phone}
            onChange={changePhone}
          />
        </div>

        <div>
          <label className="CS_Step5-label">Are You a:</label>
          <div className="CS_Step5-radioContainer">
            <div
              className={`CS_Step5-radio ${
                status === 'Homeowner' ? 'active' : ''
              } `}
              onClick={() => changeStatus('Homeowner')}
              tabIndex={0}
            >
              Homeowner
            </div>
            <div
              className={`CS_Step5-radio ${
                status === 'Trade Pro' ? 'active' : ''
              } `}
              onClick={() => changeStatus('Trade Pro')}
              tabIndex={0}
            >
              Trade Pro
            </div>
          </div>
        </div>

        <div className="CS_Step5-comment">
          <label className="CS_Step5-label">Comments</label>
          <textarea
            className="CS_Step5-textarea"
            value={comment}
            onChange={changeComment}
          ></textarea>
        </div>
      </div>

      <div className="CS_Step5-btnContainer">
        <button className="GoBack" onClick={goBack}>
          <svg
            width="16"
            height="10"
            viewBox="0 0 16 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.75 5L1.25 5M1.25 5L5.54032 0.999999M1.25 5L5.54032 9"
              stroke="#4E6280"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Back
        </button>
        {showButton === true && (
          <span
            className="o-button o-button--blue CS_Step5-btn"
            onClick={goNext}
          >
            Get Quote
          </span>
        )}
      </div>
    </div>
  )
}
